//append h2 image content
$(() => {
    const winWidth = document.documentElement.clientWidth;
    let imagecontentSection = $('.bs-section--image-content');
    if (winWidth < 767) {
        imagecontentSection.each((index, element) => {
            $(element).find(".bs-column:first-child").append($(element).find("h2"));
        })
    }

    let blurbSlider = $('.bs-section--expertise-blurbs-slider');
    if (winWidth < 767) {
        blurbSlider.each((index, element) => {
            $(element).find(".bs-row:last-child >div").append($(element).find(".bs-pro-button--orange-button"));
        })
    }

    //Home page lead revolution section
    const imageoverhover = $('.bs-section--home-lead-relovution');
    const slides = imageoverhover.find(".bs-single-slide");
    slides.each((index, element) => {
        $(element).find(".media-elements > a").append($(element).find(".bs-div--content"));
        if (!$(element).find('video').length) {
            $(element).addClass('no-video');
        } else {
            $(element).find('video').get(0).pause();
        }
    });

    if (winWidth > 1200) {
        imageoverhover.find('.media-elements > a').each((index, element) => {
            const $this = $(element);
            $this.hover(
                function () {
                    $this.parents('.bs-single-slide').addClass('hover');
                    slides.each((index, element) => {
                        if ($(element).find('video').length) {
                            $(element).find('video').get(0).pause();
                        }
                    });
                    if ($(this).parents('.bs-single-slide').find('video').length) {
                        $(this).parents('.bs-single-slide').find('video').get(0).play();
                    }
                },
                function () {
                    $this.parents('.bs-single-slide').removeClass('hover');
                    slides.each((index, element) => {
                        if ($(element).find('video').length) {
                            $(element).find('video').get(0).pause();
                        }
                    });
                }
            )
        });
    }

    $('a').removeAttr('title');

});



